import { useState, useEffect } from 'react';
import { Button } from "react-bootstrap";
import axios from 'axios';
import { useNavigate, useLocation, useParams, useSearchParams, Link } from 'react-router-dom';
import styles from './Login.css';
import { AiFillEye } from "react-icons/ai";
import { AiFillEyeInvisible } from "react-icons/ai";
import Konsensus_Constants from '../constants/index.js';

export default function Login() {
  const location = useLocation();
  const initialMessage = location.state?.message;
  // State to manage the message that can be updated later
  const [message, setMessage] = useState(initialMessage || '');
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
  }, [navigate]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
    if( showPassword ){
    }else{
    }
  };

  const handleLogin = async () => {
    let response = null;
    try {
      Konsensus_Constants.clear();
      const apiRes = await fetch(Konsensus_Constants.FORUM_URL+'/api', {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });
      const xcsrf = apiRes.headers.get('x-csrf-token');
      const rawSetCookie = apiRes.headers.get('set-cookie');

      // If you got a session cookie (may need to split for multiple cookies)
      let sessionCookie;
      if (rawSetCookie) {
        sessionCookie = rawSetCookie.split(';')[0];
      }
      const AXIOS_CONFIG = {
          headers: {
              'Content-Type':'application/json',
              'Cookie': sessionCookie,
              'X-CSRF-Token': xcsrf
          }
      }
      const AXIOS_CONFIG2 = {
          headers: {
              'Content-Type':'application/json'
          }
      }
      response = await axios.post(Konsensus_Constants.FORUM_URL+'/api/token', {
                                                                                         identification: email,
                                                                                         password: password,
                                                                            }, AXIOS_CONFIG);
      // console.log(response);
      Konsensus_Constants._storeData("login_response",response);
      let response2 = await axios.post(Konsensus_Constants.NEM_URL+'/NEM/api/api.php/login', {UserEmail: email, password: password}, AXIOS_CONFIG2);
      if( response2.data.error ){
          alert(response2.data.error);
          navigate('/chat');
      }else{
          console.log(response2)
          Konsensus_Constants._storeData("nem",response2);

          let response3 = await axios.post(Konsensus_Constants.NEM_URL+'/NEM/api/api.php/notifications', {userhash: response2.data.userhash}, AXIOS_CONFIG2);
          if( response3.data.error ){
              // alert(response3.data.error);
              console.log(response3.data.error);
          }else{
              console.log(response3);
              Konsensus_Constants._storeData("nem_notifications",response3);
          }
          navigate('/chat');
      }
    } catch(error) {
      console.log(error);
      if( response ){
        navigate('/chat');
      }else{
        console.log(error.response.data.errors[0].code);
        if( error.response.data.errors[0].code==="not_authenticated" ){
            setMessage("Login with credentials failed");
        }else{
            setMessage(error.message);
        }

      }
    }
  };

  return (
  <div style={{
                height: '100%',
                display: 'grid',
                placeItems: 'center',
              }}>
    <div style={{
                  flex: 1,
                  align: 'center',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginHorizontal: 22,
                }}>
      <img
         src={require('../assets/images/logo.png')}
         style={{
            height: 240,
            width: 340,
            marginBottom: 12,
         }}
      />
      <h2>Login</h2>
      {message && message !== "" && (
        <div className="welcome-message">{message}</div>
      )}
      <div>
        <input placeholder="Email" type="email" className="input-rounded"
          onChange={e => setEmail(e.target.value)} />
      </div>
      <div>
        <input placeholder="Password" type="password" className="input-rounded" style={{width:"90%"}} type={showPassword ? 'text' : 'password'}
          onChange={e => setPassword(e.target.value)} />
          {showPassword ? (
            <AiFillEyeInvisible onClick={togglePasswordVisibility}/>
          ) : (
            <AiFillEye onClick={togglePasswordVisibility}/>
          )}
      </div>
      <Button onClick={handleLogin} className="input-rounded2">Login</Button>
      <p>No account? <Link to="/register">Register</Link></p>
      <p><Link to="/forgotten_password">Forgotten Password</Link></p>
    </div>
  </div>
  );
}